import React from "react";
import { Box, Typography, Divider, Container } from "@mui/material";

const LimitedTimeOffer = () => {
    return (
        <Box
            id="section-ddc571c8"
            sx={{
                background: "#fff",
                py: 4,
                px: 2,
                borderRadius: 2,
                boxShadow: 2,
                width: "100%",
            }}
        >
            <Container maxWidth="md" sx={{ textAlign: "center" }}>
                {/* Headline */}
                <Typography
                    sx={{
                        color: "#000",
                        fontSize: 20,
                        fontWeight: 400,
                        mb: 2,
                    }}
                >
                    BUT WAIT, BEFORE YOU GO
                </Typography>
                {/* Limited Time Offer */}
                <Typography
                    sx={{
                        color: "#1c1e2e",
                        fontSize: 32,
                        fontWeight: 400,
                        fontStyle: "italic",
                        mb: 2,
                    }}
                >
                    <strong>
                        <em>Limited Time Offer!</em>
                    </strong>
                </Typography>
                {/* Offer Expiry Text */}
                <Typography
                    sx={{
                        color: "#4a4a4a",
                        fontFamily: "Roboto, sans-serif",
                        fontSize: 18,
                        fontWeight: 400,
                        mb: 2,
                    }}
                >
                    (This one-time offer expires as soon as you leave this page!)
                </Typography>
                {/* Recommendation Text */}
                <Typography
                    sx={{
                        color: "#010101",
                        fontSize: 32,
                        fontWeight: 400,
                        mb: 2,
                    }}
                >
                    <strong>
                        Since you're interested in <em>'My Family Chapter'</em> you might also like...
                    </strong>
                </Typography>
                {/* Horizontal Line */}
                <Divider sx={{ my: 4, borderColor: "#eee" }} />
            </Container>
        </Box>
    );
};

export default LimitedTimeOffer;
